import { ImagePreview } from "vant"

export const UPLOADER_PREVIEW_OPTIONS = {
  closeable: true,
  closeOnClickOverlay: true
}

/** 打开图片预览：支持关闭按钮、点击遮罩关闭 */
export function previewImages(urls, startPosition = 0) {
  if (!Array.isArray(urls) || !urls.length) return
  ImagePreview({
    images: urls,
    startPosition,
    ...UPLOADER_PREVIEW_OPTIONS
  })
}
